import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=1807b3cf&scoped=true&"
import script from "./SummaryList.vue?vue&type=script&lang=ts&"
export * from "./SummaryList.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryList.vue?vue&type=style&index=0&id=1807b3cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807b3cf",
  null
  
)

export default component.exports